import { render, staticRenderFns } from "./bottomBos.vue?vue&type=template&id=089bac8a&scoped=true&"
import script from "./bottomBos.vue?vue&type=script&lang=js&"
export * from "./bottomBos.vue?vue&type=script&lang=js&"
import style0 from "./bottomBos.vue?vue&type=style&index=0&id=089bac8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089bac8a",
  null
  
)

export default component.exports